/* eslint-disable func-names */
export default function (api) {
  if (typeof api !== 'function') throw new Error('入参不是一个函数');
  return function (opts, ...params) {
    return new Promise((resolve, reject) => {
      api(Object.assign({}, opts, { success: resolve, fail: reject }), ...params);
    });
  };
}
